import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
//import SplitPane from 'react-split-pane';
import SkillsCard from '../_partials/skills-card';
import store from '../store';
import DevView from '../_partials/dev-view';
import ViewSelect from '../_partials/view-select';

export default class Skills extends Component {
  constructor(props) {
    super(props);
    this.state = {
      skills: [],
      human: true,
    };
    this.storeListener = this.storeListener.bind(this);
  }

  async UNSAFE_componentWillMount() {
    const state = store.getState();
    this.setState({ skills: state.skills });

    this.unsubscribeStore = store.subscribe(this.storeListener);
  }

  UNSAFE_componentWillUnmount() {
    this.unsubscribeStore();
  }

  handleChange(viewState) {
    this.setState({ human: !viewState });
  }

  storeListener() {
    const state = store.getState();
    this.setState({ skills: state.skills });

    //console.log(this.state.skills);
  }

  getView() {
    if (this.state.human) {
      return this.getSkills(this.state.skills);
    } else {
      return <DevView data={this.state.skills} />;
    }
  }
  getSkills(skills) {
    const skillsGroups = {};
    skills.map(skill => {
      if (skillsGroups[skill.type]) {
        skillsGroups[skill.type].push(skill);
      } else {
        skillsGroups[skill.type] = [skill];
      }
    });
    return Object.keys(skillsGroups).map(group => {
      return (
        <Col xs="12" md="6">
          <SkillsCard
            heading={group.replace(group[0], group[0].toUpperCase())}
            skills={skillsGroups[group]}
          ></SkillsCard>
        </Col>
      );
    });
  }
  render() {
    return (
      <Row className="portfolio__block" id="skills">
        <Col>
          <h3 className="portfolio__block__heading">skills</h3>
          <div className="portfolio__block__skills">
            <ViewSelect onChange={this.handleChange.bind(this, this.state.human)} />
            <hr></hr>
            <Row>{this.getView()}</Row>
          </div>
        </Col>
      </Row>
    );
  }
}
